/*
 * 생성 파일 — 손으로 고치지 않는다.
 *
 * 원본은 `translations/messages.*.yaml` 과 `scripts/build-locales.mjs` 의 LOCALES 다.
 * `npm run build:locales` 가 만들고 `npm run check:locales` 가 동기를 확인한다.
 */
import en from './en.json'
import ko from './ko.json'
import es from './es.json'

/** 화면에서 고를 수 있는 언어. Symfony 의 `enabled_locales` 와 같은 순서다. */
export const APP_LOCALES = ['en', 'ko', 'es'] as const

export type AppLocale = (typeof APP_LOCALES)[number]

export const messages = { en, ko, es }

export function isAppLocale(value: unknown): value is AppLocale {
  return APP_LOCALES.includes(value as AppLocale)
}
